export default __webpack_public_path__ + "media/images/home-app-ios-37baf3d3.png";